import { Injectable } from "@angular/core";
import { SwHttpClientService } from "src/app/librarys/serves/sw-http-client.service";
import { environment } from "src/environments/environment";
import { SwExportService } from "../../librarys/serves/public/sw-export.service";

@Injectable({
  providedIn: "root",
})
export class KmsService {
  prefix: string = environment.kgsWebAPI;
  kgBasicApi: string = environment.kgsBasicApi;
  rmsBasicApi: string = environment.rmsBasicApi;
  mapBasicApi: string = environment.mapBasicApi;
  sesWebBasicApi: string = environment.sesWebBasicApi;
  imgSegmentationApi: string = environment.imgSegmentationApi;
  ocrApi: string = environment.ocrApi;

  // 文件处理微服务api
  filePrefix: string = environment.fileWebAPI;

  //基础平台微服务api
  basicApi: string = environment.seekerWebAPI;

  constructor(
    private http: SwHttpClientService,
    private exportService: SwExportService
  ) {}

  //==============================================公用方法====================================================

  // Get导出公共方法(excel)
  exportExcelForGet(url, fileName) {
    this.exportService.getExportExcel(url, fileName);
  }

  // Post导出公共方法(excel)
  exportExcelForPost(url, param, fileName) {
    this.exportService.PostExportExcel(url, param, fileName);
  }

  /**
   * 根据配置key查询子配置参数
   * @param configKey 配置key
   */
  queryApplicationConfigSonsByConfigKey(configKey) {
    let param = {
      str: configKey,
    };
    const url = this.basicApi +  "applicationConfig/queryApplicationConfigSonsByConfigKey";
    return this.http.Post(url, param);
  }

  //#region 工作流 start

  // 启动审批流程
  startActiviti(param) {
    const url =
      environment.activitiWebAPI + "activitiRunTime/startPIWithIdAndVar";
    return this.http.Post(url, param);
  }

  // 获取当前用户所有代办信息
  getProcessToDos(x?, y?) {
    const url =
      environment.activitiWebAPI + "swActivitiTaskRecord/getPersonalTaskList";
    if (x && y) {
      return this.http.Post(url, {
        pageNum: x,
        pageSize: y,
      });
    } else {
      return this.http.Post(url, {
        pageSize: 200,
      });
    }
  }

  // 保存待发流程
  saveTodoProcess(param) {
    const url = environment.activitiWebAPI + "todoProcess/save";
    return this.http.Post(url, param);
  }

  // 删除待发流程
  deleteTodoProcess(param) {
    const url = environment.activitiWebAPI + "todoProcess/delete";
    return this.http.Post(url, param);
  }

  // 获取主键id
  getPrimaryId() {
    const url = this.prefix + "common/getPrimaryId";
    return this.http.Get(url);
  }

  //#endregion  工作流 end

  // 查询行政区域字典项
  getAdministrativeDivisionList(param) {
    const url = this.basicApi + 'region/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 分页查询组织
   * @param param
   * @returns {Observable<any>}
   */
  queryOrganizePageList(param) {
    const url = this.basicApi + "organize/queryPageList";
    return this.http.Post(url, param);
  }
  
  /**
   * 关联查询
   * @param param
   * @returns {Observable<any>}
   */
  queryUserByOrganizeId(param) {
    const url = this.basicApi + "user/queryUserByOrganizeId";
    return this.http.Post(url, param);
  }

  // =============================控制台===============================
  // 知识库概况统计
  statisticKnowledgebaseById() {
    const url = this.prefix + "indexStatistic/queryKnowledgebaseTotalCount";
    return this.http.Get(url);
  }

  // 首页任务统计
  taskStatistic(param) {
    const url = this.prefix + "indexStatistic/queryStatisticByCurrentUser";
    return this.http.Post(url, param);
  }

  // 反向更新知识库数据统计
  asynchKnowledgebaseTotal(param) {
    const url = this.prefix + "indexStatistic/asynchKnowledgebaseTotal";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 实体数据分类统计查询
  statisticInstanceByConcept(param,tenantId?) {
    const url = this.prefix + "indexStatistic/statisticInstanceByConcept";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },tenantId);
  }

  // 实体地域分布统计查询
  statisticGeoDistribution(param,tenantId?) {
    const url = this.prefix + "indexStatistic/statisticGeoDistribution";
    return this.http.Post(url, param,{
      'Content-Type' :'application/json',
      'Accept':'application/json'
    },tenantId);
  }

  // 根据质检人、质检时间导出质检记录
  exportCheckRecord(param) {
    const name =  param.recordType == 0 ? '实体质检记录' : '图像标记质检记录';
    const url = this.prefix + "indexStatistic/exportCheckRecord";
    this.exportService.PostExportExcel(url,param, name);
  }

  // ******************************控制台（新）******************************
  // 根据素材类型统计资源
  materialStatistic(param) {
    const url = this.rmsBasicApi + "material/materialStatistic";
    return this.http.Post(url, param);
  }

  // 文档资源类型统计
  materialTypeStatistic(param) {
    const url = this.rmsBasicApi + "material/materialTypeStatistic";
    return this.http.Post(url, param);
  }

  // 资源研究主题统计
  materiaThemeStatistic(param) {
    const url = this.rmsBasicApi + "material/materiaThemeStatistic";
    return this.http.Post(url, param);
  }

  // 图书统计
  bookStatistic(param) {
    const url = this.rmsBasicApi + "material/bookStatistic";
    return this.http.Post(url, param);
  }

  // 论文发表时间统计
  paperPublishTimeStatistic(param) {
    const url = this.rmsBasicApi + "material/paperPublishTimeStatistic";
    return this.http.Post(url, param);
  }

  // 图像标记统计
  imageMarkStatistic(param) {
    const url = this.rmsBasicApi + "material/imageMarkStatistic";
    return this.http.Post(url, param);
  }

  // 实体分类统计
  instanceClassifiStatistic(param) {
    const url = this.rmsBasicApi + "material/instanceClassifiStatistic";
    return this.http.Post(url, param);
  }

  // 知识生产任务统计
  instanceProdTaskStatistic(param) {
    const url = this.rmsBasicApi + "material/instanceProdTaskStatistic";
    return this.http.Post(url, param);
  }

  // 三元组总数查询
  relatedTotalStatistic(param) {
    const url = this.rmsBasicApi + "material/relatedTotalStatistic";
    return this.http.Post(url, param);
  }

  // =============================模型管理===============================
  // 查询模型数据
  getOntologyModel(param) {
    const url = this.kgBasicApi + "ontologyModel/queryList";
    return this.http.Post(url, param);
  }

  // 模型新增、模型重命名
  saveOrUpdateModel(param) {
    const url = this.kgBasicApi + "ontologyModel/saveOrUpdateOwl";
    return this.http.Post(url, param);
  }

  // 通过主键id查询模型信息
  queryModelById(id) {
    const url = this.kgBasicApi + "ontologyModel/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除模型信息
  deleteModelById(param) {
    const url = this.kgBasicApi + "ontologyModel/deleteByIds";
    return this.http.Post(url, param);
  }

  // 更新模型历史版本信息
  updateRecordInfo(param) {
    const url = this.kgBasicApi + "ontologyModel/updateRecordInfo";
    return this.http.Post(url, param);
  }

  // 通过模型版本id查询历史版本信息
  queryRecordInfoById(id) {
    const url = this.kgBasicApi + "ontologyModel/queryRecordInfoById/" + id;
    return this.http.Get(url);
  }

  // 删除模型历史版本信息
  deleteRecordInfo(param) {
    const url = this.kgBasicApi + "ontologyModel/deleteMviByIds";
    return this.http.Post(url, param);
  }

  // 上传本体模型文件
  importModel(param) {
    const url = this.kgBasicApi + "ontologyModel/importModule";
    return this.http.Post(url, param);
  }

  // 查询所有可用的模型数据
  queryUsableModelList(param) {
    const url = this.kgBasicApi + "ontologyModel/queryUsableList";
    return this.http.Post(url, param);
  }

  // 导出本体模型的概念属性，生成owl文件
  exportModelFile(param) {
    const url = this.kgBasicApi + "ontologyModel/exportModelFile/" + param;
    return this.http.Get(url);
  }

  // 通过模型版本id查询本体模型的概念树
  queryModelTree(param) {
    const url = this.kgBasicApi + "ontologyModel/queryModelTree";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 查询所有的模型信息，最新版本
  queryAllModel(param) {
    const url = this.kgBasicApi + "ontologyModel/queryAllList";
    return this.http.Post(url, param);
  }

  // 查询审核通过的模型信息，审核通过最新版本
  queryApprovedModel(param) {
    const url = this.kgBasicApi + "ontologyModel/queryApprovedList";
    return this.http.Post(url, param);
  }

  // =============================概念管理===============================
  // 查询概念树数据
  getConceptTree(param) {
    const url = this.kgBasicApi + "concept/queryTreeList/" + param;
    return this.http.Get(url);
  }

  // 查询概念树数据
  queryTreeListWithAttrs(param) {
    const url = this.kgBasicApi + "concept/queryTreeListWithAttrs/" + param;
    return this.http.Get(url);
  }

  // 保存，更新概念数据
  saveConceptUpdate(param) {
    const url = this.kgBasicApi + "concept/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 复制概念数据
  copyConcept(param) {
    const url = this.kgBasicApi + "concept/copyConcept";
    return this.http.Post(url, param);
  }

  // 通过主键id查询概念信息
  getConceptById(id) {
    const url = this.kgBasicApi + "concept/queryById/" + id;
    return this.http.Get(url);
  }

  // 删除概念
  deleteConceptById(id) {
    const url = this.kgBasicApi + "concept/deleteConceptById/" + id;
    return this.http.Get(url);
  }

  // 概念排序
  updateConceptSortNumById(param) {
    const url = this.kgBasicApi + "concept/updateSortNumById";
    return this.http.Post(url, param);
  }

  // 通过自增Id修改概念名称
  updateConceptName(param) {
    const url = this.kgBasicApi + "concept/updateConceptName";
    return this.http.Post(url, param);
  }
  // =============================属性管理===============================
  // 分页查询本体属性数据
  getOntologyQueryList(param) {
    const url = this.kgBasicApi + "ontologyAttribute/queryList";
    return this.http.Post(url, param);
  }

  // 保存，更新本体属性信息(多条)
  saveMultipleOntologyUpdate(param) {
    const url = this.kgBasicApi + "ontologyAttribute/batchSave";
    return this.http.Post(url, param);
  }

  // 保存，更新本体属性信息(单条)
  saveSingleOntologyUpdate(param) {
    const url = this.kgBasicApi + "ontologyAttribute/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id查询本体属性信息
  getOntologyById(id) {
    const url = this.kgBasicApi + "ontologyAttribute/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除本体属性信息
  deleteOntologyById(param) {
    const url = this.kgBasicApi + "ontologyAttribute/deleteById/" + param;
    return this.http.Post(url, {});
  }

  // 通过主键id删除本体属性信息
  queryeAttrTreeList(param) {
    const url = this.kgBasicApi + "ontologyAttribute/queryTreeList";
    return this.http.Post(url, param);
  }

  // 属性排序
  updateAttrSortNumById(param) {
    const url = this.kgBasicApi + "ontologyAttribute/updateSortNumById";
    return this.http.Post(url, param);
  }

  // 通过自增Id修改属性名称
  updateAttributeName(param) {
    const url = this.kgBasicApi + "ontologyAttribute/updateAttributeName";
    return this.http.Post(url, param);
  }

  // =============================本体属性管理（知识库）===============================
  // 查询概念数据
  getConceptQueryListPrefix(param) {
    const url = this.prefix + "concept/queryList";
    return this.http.Post(url, param);
  }

  // 查询概念属性树数据
  getInstanceConceptQueryList(param) {
    const url = this.prefix + "concept/queryConceptTree";
    return this.http.Post(url, param);
  }

  // 查询概念树数据
  getConceptTreeData(param) {
    const url = this.prefix + "concept/queryTree";
    return this.http.Post(url, param);
  }

  // 通过概念id查询表单生成属性
  getAttributeForForm(id) {
    const url = this.prefix + "ontologyAttribute/queryAttributeForForm/" + id;
    return this.http.Get(url);
  }

  // 分页查询属性列表
  getOntologyAttributeList(param) {
    const url = this.prefix + "ontologyAttribute/queryList";
    return this.http.Post(url, param);
  }

  // 查看属性详情
  queryOntologyAttributeById(id) {
    const url = this.prefix + "ontologyAttribute/queryById/" + id;
    return this.http.Get(url);
  }

  // 根据父级属性id查询所有子属性信息

  // =============================关系管理===============================
  // 查询概念关系树数据
  getRelationTreeList(param) {
    const url = this.kgBasicApi + "conceptRelationship/queryTreeList";
    return this.http.Post(url, param);
  }

  // 查询概念关系
  getRelationDatas(param){
    const url = this.kgBasicApi + "conceptRelationship/queryConceptRelList";
    return this.http.Post(url, param);
  }

  // 通过关系主键查询关系
  getConceptRelationById(id) {
    const url = this.kgBasicApi + "relationship/queryById/" + id;
    return this.http.Get(url);
  }

  // 新增关系
  saveRelationship(param) {
    const url = this.kgBasicApi + "relationship/saveRelationship";
    return this.http.Post(url, param);
  }

  // 编辑关系
  updateRelationship(param) {
    const url = this.kgBasicApi + "relationship/updateRelationship";
    return this.http.Post(url, param);
  }

  // 删除关系
  deleteConceptRelationById(id) {
    const url = this.kgBasicApi + "relationship/deleteById/" + id;
    return this.http.Get(url);
  }

  // 概念关系排序
  updateRelSortNumById(param) {
    const url = this.kgBasicApi + "relationship/updateSortNumById";
    return this.http.Post(url, param);
  }

  // 通过主键id删除概念配置
  deleteConcepts(id) {
    const url = this.kgBasicApi + "conceptRelationship/deleteById/" + id;
    return this.http.Post(url, {});
  }

  // 复制概念关系配置数据
  relationshipCopy(param) {
    const url = this.kgBasicApi + "conceptRelationship/relationshipCopy";
    return this.http.Post(url, param);
  }

  // 通过自增Id修改关系名称
  updateRelationName(param) {
    const url = this.kgBasicApi + "relationship/updateRelationName";
    return this.http.Post(url, param);
  }
  // =============================本体关系管理（知识库）===============================
  // 查询概念关系树数据
  getRelationTreeListPrefix(param) {
    const url = this.prefix + "conceptRelationship/queryTreeList";
    return this.http.Post(url, param);
  }

  // 新增关系
  addRelation(param) {
    const url = this.prefix + "conceptRelationship/saveRelationship";
    return this.http.Post(url, param);
  }

  // 编辑关系
  editRelation(param) {
    const url = this.prefix + "conceptRelationship/updateRelationship";
    return this.http.Post(url, param);
  }

  // 查看关系
  queryRelation(param) {
    const url = this.prefix + "conceptRelationship/queryById/" + param;
    return this.http.Get(url);
  }

  // =============================知识库管理===============================
  // 分页查询知识库数据
  getknowledgebaseList(param) {
    const url = this.kgBasicApi + "knowledgebase/queryList";
    return this.http.Post(url, param);
  }

  // 保存，更新知识库数据
  saveOrUpdateknowledgebase(param) {
    const url = this.kgBasicApi + "knowledgebase/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id查询知识库信息
  getknowledgebaseById(id) {
    const url = this.kgBasicApi + "knowledgebase/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除知识库数据
  deleteknowledgebaseById(param) {
    const url = this.kgBasicApi + "knowledgebase/deleteById";
    return this.http.Post(url, param);
  }

  // 查询所有可用知识库数据
  queryUseableKnowledgebaseList(param) {
    const url = this.kgBasicApi + "knowledgebase/queryUseableList";
    return this.http.Post(url, param);
  }

  // 通过知识库id查询关联的用户数据
  queryByknowledgebaseId(param) {
    const url =
      this.kgBasicApi + "knowledgebase/queryByknowledgebaseId/" + param;
    return this.http.Get(url);
  }

  // 保存/更新用户-知识库关联数据
  saveOrUpdateRelatedUsers(param) {
    const url = this.kgBasicApi + "knowledgebase/saveUserKnowledgebase";
    return this.http.Post(url, param);
  }

  // 统计知识库信息
  queryKnowledgebaseTotalCount(param) {
    const url = this.kgBasicApi + "knowledgebase/queryKnowledgebaseTotalCount";
    return this.http.Post(url, param);
  }

  // =============================实体管理===============================
  // 分页查询实体数据
  getInstanceQueryList(param) {
    const url = this.prefix + "instance/queryList";
    return this.http.Post(url, param);
  }

  // 保存，更新实体数据
  saveInstanceUpdate(param) {
    const url = this.prefix + "instance/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id查询实体基本信息
  getInstanceById(id) {
    const url = this.prefix + "instance/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除实体数据进回收站
  deleteInstanceById(param) {
    const url = this.prefix + "instance/deleteById";
    return this.http.Post(url, param);
  }

  // 清除缓存 1：清除实例缓存 2：清除模型缓存
  deleteCache(index) {
    const url = this.prefix + "concept/clearCache?index=" + index;
    return this.http.Get(url);
  }

  // 通过主键id删除实体的属性节点
  deleteInstanceByAttribute(param) {
    const url = this.prefix + "instance/deleteAttributeByInstance";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 根据年份获取历史年份数据
  getInstanceTimeNoteByYear(id) {
    const url = this.prefix + "reign/getTimeNoteByYear/" + id;
    return this.http.Get(url);
  }

  // 保存一个实体及节点数据
  saveInstanceOneUpdate(param) {
    const url = this.prefix + "instance/saveInstance";
    return this.http.Post(url, param);
  }

  // 查询素材关联实体历史记录数据
  queryMaterialRecordList(param) {
    const url = this.prefix + "instance/queryMaterialRecordList";
    return this.http.Post(url, param);
  }

  // 保存更新实体信息后，需同步更新索引
  updateIndexByInstanceId(param) {
    const url = this.sesWebBasicApi + "indexInfo/updateIndexByInstanceId";
    return this.http.Get(url + "/" + param);
  }

  // 根据实体标识删除索引记录
  deleteIndexByInstanceId(param) {
    const url = this.sesWebBasicApi + "instanceInfo/deleteInstanceInfo";
    return this.http.Post(url , param);
  }

  // 更新索引实体记录审核状态
  updateInstanceInfoApprovalStatus(param) {
    const url = this.sesWebBasicApi + "instanceInfo/updateInstanceInfoApprovalStatus";
    return this.http.Post(url , param);
  }

  // 分页查询回收站实体数据
  getInstanceRecycleList(param) {
    const url = this.prefix + "instance/queryRecycleList";
    return this.http.Post(url, param);
  }

  // 通过主键id从回收站彻底删除实体数据
  deleteInstanceByIdRecycle(param) {
    const url = this.prefix + "instance/removeRecycleById";
    return this.http.Post(url, param);
  }

  // 通过主键id从回收站还原实体数据
  updateInstanceByIdRecycle(param) {
    const url = this.prefix + "instance/reductionRecycleById";
    return this.http.Post(url, param);
  }

  // 根据主键id查询实体审核状态
  queryApprovalStatusById(param) {
    const url = this.prefix + "instance/queryApprovalStatusById/" + param;
    return this.http.Get(url);
  }

  // 实体指派、申领、分配质检员
  batchUpdateEditorAndCheckUser(param) {
    const url = this.prefix + "instance/batchUpdateEditorAndCheckUser";
    return this.http.Post(url, param);
  }

  // 批量更新实体状态(提交质检、质检、批量驳回、发布、撤销发布)
  batchUpdateStatus(param) {
    const url = this.prefix + "instance/batchUpdateStatus";
    return this.http.Post(url, param);
  }

  // 单条质检通过、驳回；返回下一条待质检实体
  queryNextApprovalId(param) {
    const url = this.prefix + "instance/queryNextApprovalId";
    return this.http.Post(url, param);
  }

  // 单条保存成功、提交质检成功、发布成功：返回下一条待编辑实体
  queryNextInstanceByUser(param) {
    const url = this.prefix + "instance/queryNextInstanceByUser";
    return this.http.Post(url, param);
  }

  // 通过关联数据id查询质检问题记录
  queryLatestApprovedRecord(param) {
    const url = this.prefix + "approvedRecord/queryLatestApprovedRecord/" + param;
    return this.http.Get(url);
  }
  
  // =============================实体-复合属性管理===============================
  // 分页查询复合属性数据
  queryCompositeList(param) {
    const url = this.prefix + "composite/queryPage";
    return this.http.Post(url, param);
  }

  // 保存复合属性信息
  saveCompositeAttribute(param) {
    const url = this.prefix + "composite/saveCompositeAttribute";
    return this.http.Post(url, param);
  }

  // 修改复合属性信息
  updateCompositeAttribute(param) {
    const url = this.prefix + "composite/updateCompositeAttribute";
    return this.http.Post(url, param);
  }

  // 修改复合属性排序号
  updateCompositeAttrSortNum(param) {
    const url = this.prefix + "composite/updateCompSortNumEdit";
    return this.http.Post(url, param);
  }

  // 根据id查询复合属性信息
  queryCompositeAttributeById(param) {
    const url = this.prefix + "composite/queryById/" + param;
    return this.http.Get(url);
  }

  // 根据id删除复合属性信息
  deleteCompositeAttributeById(param) {
    const url = this.prefix + "composite/deleteById/" + param;
    return this.http.Get(url);
  }

  // 批量删除复合属性信息
  deleteCompositeAttributeByIds(param) {
    const url = this.prefix + "composite/deleteByIds";
    return this.http.Post(url, param);
  }

  // =============================实体关系配置===============================

  // 实体关系分页查询
  getRelationshipList(param) {
    const url = this.prefix + "instanceRelationship/queryList";
    return this.http.Post(url, param);
  }

  // 批量保存实体关系数据
  saveRelationshipBatchUpdate(param) {
    const url = this.prefix + "instanceRelationship/batchSave";
    return this.http.Post(url, param);
  }

  // 单条保存实体关系数据
  saveRelationshipUpdate(param) {
    const url = this.prefix + "instanceRelationship/saveOrUpdateInstanceRelationship";
    return this.http.Post(url, param);
  }

  // 通过主键id删除实体关系数据
  deleteRelationshipById(param) {
    const url = this.prefix + "instanceRelationship/batchDelete";
    return this.http.Post(url, param);
  }

  // 查询单个实体关系数据
  getRelationshipById(param) {
    const url = this.prefix + "instanceRelationship/queryRelationshipById";
    return this.http.Post(url, param);
  }

  // 通过参数查询实体关系数据
  getRelationshipByParam(param) {
    const url = this.prefix + "instanceRelationship/queryRelationshipByParam";
    return this.http.Post(url, param);
  }

  // =============================图谱可视化===============================

  // 通过参数查询节点数据
  getNodeByParam(param) {
    const url = this.prefix + "graphNode/findNodeByParam";
    return this.http.Post(url, param);
  }

  // 通过参数查询关系路径数据
  queryPathByParam(param) {
    const url = this.prefix + "v2/graph/queryPath";
    return this.http.Post(url, param);
  }

  // 通过起始节点名称查询当前节点的所有关系信息
  queryRelationsByNodeName(nodeName) {
    const url =
      this.prefix + "conceptRelationship/queryTreeByInstanceName/" + nodeName;
    return this.http.Get(url);
  }
  // =============================系统编号管理===============================

  // 通过标识自动生成序列号数据
  getInstanceMaxSerialNumber() {
    const url = this.prefix + "serialNumber/findMaxSerialNumber";
    return this.http.Get(url);
  }

  // 分页查询序列号配置数据
  getSerialNumberList(param) {
    const url = this.prefix + "serialNumber/queryList";
    return this.http.Post(url, param);
  }

  // 查询单个序列号配置数据
  getSerialNumberById(id) {
    const url = this.prefix + "serialNumber/queryById/" + id;
    return this.http.Get(url);
  }

  // 删除单个序列号配置数据
  deleteSerialNumberById(param) {
    const url = this.prefix + "serialNumber/deleteById";
    return this.http.Post(url, param);
  }

  // 保存、更新序列号配置数据
  saveSerialNumberUpdate(param) {
    const url = this.prefix + "serialNumber/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // =============================抓取源管理===============================

  // 查询抓取源数据
  getCrawlWebsite(param) {
    const url = this.rmsBasicApi + "crawlWebsite/queryList";
    return this.http.Post(url, param);
  }

  // 保存，更新抓取源数据
  saveOrUpdateCrawlWebsite(param) {
    const url = this.rmsBasicApi + "crawlWebsite/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id查询抓取源型信息
  queryCrawlWebsiteById(id) {
    const url = this.rmsBasicApi + "crawlWebsite/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除抓取源信息
  deleteCrawlWebsiteById(param) {
    const url = this.rmsBasicApi + "crawlWebsite/deleteById";
    return this.http.Post(url, param);
  }

  // =============================抓取任务管理===============================
  // 分页查询抓取任务数据
  getCrawlTask(param) {
    const url = this.rmsBasicApi + "crawlTask/queryList";
    return this.http.Post(url, param);
  }

  // 保存/更新抓取任务数据
  saveOrUpdateCrawlTask(param) {
    const url = this.rmsBasicApi + "crawlTask/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id查询抓取任务数据
  queryCrawlTaskById(id) {
    const url = this.rmsBasicApi + "crawlTask/queryById/" + id;
    return this.http.Get(url);
  }

  // 通过主键id删除抓取任务数据
  deleteCrawlTaskById(param) {
    const url = this.rmsBasicApi + "crawlTask/deleteById";
    return this.http.Post(url, param);
  }

  // 启动抓取服务
  startCrawlService(param) {
    const url = this.rmsBasicApi + "crawlTask/startCrawlService";
    return this.http.Post(url, param);
  }

  // 通过任务id启动抓取任务
  startTask(param) {
    const url = this.rmsBasicApi + "crawlTask/startTask";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // =============================素材导入及解析===============================
  // 通过素材id启动素材ocr识别任务
  runProcessTask(params) {
    const url = this.rmsBasicApi + "material/runProcessTaskV2";
    return this.http.Post(url, params, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 批量ocr识别
  resourceOcrByIds(params) {
    const url = this.rmsBasicApi + "material/ocrByIds";
    return this.http.Post(url, params);
  }

  // 修改素材解析状态
  updateMaterialTextExtractStatus(param) {
    const url = this.rmsBasicApi + "material/updateMaterialTextExtractStatus";
    return this.http.Post(url, param);
  }

  // 重新解析pdf某一页的数据
  resolveOnePage(param){
    const url = this.rmsBasicApi + "materialDetail/reidentifyTextMaterialV2";
    return this.http.Post(url, 'url='+param.url, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // =============================素材管理===============================
  // 分页查询素材资源数据
  queryMaterialList(param) {
    const url = this.rmsBasicApi + "material/queryList";
    return this.http.Post(url, param);
  }

  // 通过主键id查询素材资源数据(基本信息和著录信息)
  queryMaterialById(param) {
    const url = this.rmsBasicApi + "material/queryById/" + param;
    return this.http.Get(url);
  }

  // 保存/更新素材资源
  saveOrUpdateMaterial(param) {
    const url = this.rmsBasicApi + "material/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 手动添加素材
  saveMaterialInfo(param) {
    const url = this.rmsBasicApi + "material/saveOrUpdateMaterialInfo";
    return this.http.Post(url, param);
  }

  // 通过主键id删除素材资源数据
  deleteMaterialById(param) {
    const url = this.rmsBasicApi + "material/deleteById";
    return this.http.Post(url, param);
  }

  // 新增、编辑素材信息时更新es
  updateESMaterialInfo(param) {
    const url = this.rmsBasicApi + 'esMaterial/syncUrl';
    return this.http.Post(url, param.materialIdList);
  }

  // 删除素材信息时更新es
  deleteESMaterialInfo(param) {
    const url = this.rmsBasicApi + 'esMaterial/deleteByIds';
    return this.http.Post(url, param.materialIdList);
  }

  // 通过素材主键id查询所有素材内容(文档、图片、网页文字内容)
  findByMaterialId(param) {
    const url = this.rmsBasicApi + "materialDetail/findByMaterialId/" + param;
    return this.http.Get(url);
  }

  // 通过素材某一页的主键id查询当前页的素材内容(文档、图片、网页文字内容)
  queryByDetailId(param) {
    const url = this.rmsBasicApi + "materialDetail/queryByDetailId";
    return this.http.Post(url,param);
  }

  // 分页查询素材详情
  queryDetailList(param) {
    const url = this.rmsBasicApi + "materialDetail/queryList";
    return this.http.Post(url,param);
  }

  // 批量更新素材内容
  batchSaveMaterialDetail(param) {
    const url = this.rmsBasicApi + "materialDetail/batchSaveOrUpdate";
    return this.http.Post(url, param);
  }

  // 单条更新素材内容
  updateMaterialDetail(param) {
    const url = this.rmsBasicApi + "materialDetail/updateMaterialDetail";
    return this.http.Post(url, param);
  }

  // 插入分页（把素材内容拆分成两页）
  addPage(param) {
    const url = this.rmsBasicApi + "materialDetail/addPage";
    return this.http.Post(url, param);
  }

  // 素材文本根据页数（更新索引）
  addPageIndex(param){
    const url = this.rmsBasicApi + "materialDetail/addPageIndex";
    return this.http.Post(url, param);
  }

  // 删除素材单页内容
  deleteMaterialDetail(param) {
    const url = this.rmsBasicApi + "materialDetail/deleteMaterialDetail/" + param;
    return this.http.Get(url);
  }

  // 解析导入文件文本内容
  parseTextFile(param) {
    const url = this.rmsBasicApi + "materialImport/parseTextFile";
    return this.http.Post(url, param);
  }

  // 新增素材详细数据
  addMaterialDetail(param) {
    const url = this.rmsBasicApi + "materialDetail/addMaterialDetail";
    return this.http.Post(url, param);
  }

  // 素材目录配置
  // 查询素材目录
  queryMaterialMenuList(param) {
    const url = this.rmsBasicApi + "materialMenu/queryList/" + param;
    return this.http.Get(url);
  }

  // 通过主键id查询素材目录
  queryMaterialMenuById(param) {
    const url = this.rmsBasicApi + "materialMenu/queryById/" + param;
    return this.http.Get(url);
  }

  // 保存/更新素材目录
  saveOrUpdateMaterialMenu(param) {
    const url = this.rmsBasicApi + "materialMenu/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过主键id删除素材目录
  deleteMaterialMenuById(param) {
    const url = this.rmsBasicApi + "materialMenu/deleteById";
    return this.http.Post(url, param);
  }

  // 素材-图像表格管理
  // 查询素材图像表格
  queryPicTableList(param) {
    const url = this.rmsBasicApi + "materialIndex/queryPicTableList";
    return this.http.Post(url, param);
  }

  // 保存素材资源图像表格信息
  saveMaterialRel(param) {
    const url = this.rmsBasicApi + "material/saveMaterialRel";
    return this.http.Post(url, param);
  }

  // 修改素材资源图像表格信息
  updateMaterialRel(param) {
    const url = this.rmsBasicApi + "material/updateMaterialRel";
    return this.http.Post(url, param);
  }

  // 根据关联标识查询关联图像表格
  queryMaterialPicOrTableById(param) {
    const url = this.rmsBasicApi + "materialIndex/queryPicTableById/" + param;
    return this.http.Get(url);
  }

  // 根据关联标识删除关联图像表格
  delteMaterialRelById(param) {
    const url = this.rmsBasicApi + "material/delteMaterialRelById/" + param;
    return this.http.Get(url);
  }
  
  // 全站素材内容检索
  fullTextQuery(param) {
    const url = this.rmsBasicApi + "materialIndex/fullTextQuery";
    return this.http.Post(url, param);
  }

  // 资源检索
  esResourceSearch(param) {
    const url = this.rmsBasicApi + "es/resourceSearch";
    return this.http.Post(url, param);
  }

  // 高级检索
  esResourceMatchQuery(param) {
    const url = this.rmsBasicApi + "es/matchQuery";
    return this.http.Post(url, param);
  }

  // ----------------资源云目录管理相关接口------------------------
  // 查询当前空间所有资源云目录
  queryAllCatalog() {
    const url = this.rmsBasicApi + "rmsCatalog/queryAll";
    return this.http.Post(url,{});
  }

  // 保存资源云目录
  saveRmsCatalog(params) {
    const url = this.rmsBasicApi + "rmsCatalog/save";
    return this.http.Post(url, params);
  }

  // 用于新建空间时，默认新增一条根目录数据
  saveRmsCatalogObj(params) {
    const url = this.rmsBasicApi + "rmsCatalog/saveObj";
    return this.http.Post(url, params);
  }
  
  // 更新资源云目录
  updateRmsCatalog(params) {
    const url = this.rmsBasicApi + "rmsCatalog/update";
    return this.http.Post(url, params);
  }
  
  // 删除资源云目录
  deleteRmsCatalogById(params) {
    const url = this.rmsBasicApi + "rmsCatalog/deleteById/"+params;
    return this.http.Get(url);
  }

  // 同一层级下是否存在同名目录
  queryOneRmsCatalog(params) {
    const url = this.rmsBasicApi + "rmsCatalog/queryOne";
    return this.http.Post(url, params);
  }

  // 获取资源云目录
  queryRmsCatalogById(params) {
    const url = this.rmsBasicApi + "rmsCatalog/getById/";
    return this.http.Get(url+params);
  }

  // =================================知识提取任务管理==================================
  // 分页查询待知识提取的资源列表
  queryExtractResourceList(param) {
    const url = this.rmsBasicApi + "materialExtract/queryList";
    return this.http.Post(url, param);
  }

  // 批量新增资源页，作为知识提取的素材
  saveExtractResources(param) {
    const url = this.rmsBasicApi + "materialExtract/saveMaterialExtract";
    return this.http.Post(url, param);
  }

  // 清空当前用户选择的所有资源
  removeAllExtractResources(params) {
    const url = this.rmsBasicApi + "materialExtract/removeAll";
    return this.http.Get(url+'/'+params);
  }

  // 从待知识提取的资源列表删除某一条
  deleteExtractResource(params) {
    const url = this.rmsBasicApi + "materialExtract/deleteByExtractId";
    return this.http.Get(url+'/'+params);
  }

  // 生成知识提取任务编码 
  genKeTaskCode() {
    const url = this.rmsBasicApi + "keTask/genCode";
    return this.http.Get(url);
  }

  // 分页查询知识提取任务
  queryKeTaskList(param) {
    const url = this.rmsBasicApi + "keTask/queryList";
    return this.http.Post(url, param);
  }

  // 批量删除知识提取任务
  deleteKeTaskByIds(param) {
    const url = this.rmsBasicApi + "keTask/deleteByIds";
    return this.http.Post(url, param);
  }

  // 获取知识提取任务详情 
  getKeTaskById(param) {
    const url = this.rmsBasicApi + "keTask/getById";
    return this.http.Get(url+'/'+param);
  }

  // 根据任务id查询抽取素材列表 
  queryExtractMaterialList(param) {
    const url = this.rmsBasicApi + "keTask/queryMaterialList";
    return this.http.Get(url+'/'+param);
  }

  // 保存知识提取任务
  saveKeTask(param) {
    const url = this.rmsBasicApi + "keTask/save";
    return this.http.Post(url, param);
  }

  // 启动知识提取任务
  startKeTask(param) {
    const url = this.rmsBasicApi + "keTask/startTask";
    return this.http.Get(url+'/'+param);
  }

  // 停止知识提取任务
  endTask(param) {
    const url = this.rmsBasicApi + "keTask/endTask";
    return this.http.Get(url+'/'+param);
  }

  // 修改知识提取结果
  updateKeResult(param) {
    const url = this.rmsBasicApi + "keTask/updateKeResult";
    return this.http.Post(url,param);
  }

  // 将提取结果发布到知识库
  taskPublish(param) {
    const url = this.rmsBasicApi + "keTask/publish";
    return this.http.Get(url+'/'+param);
  }

  
  // 通过任务标识导出Excel
  exportExcelByTaskId(param) {
    const url = this.rmsBasicApi + "export/exportExcelByTaskId?taskId=" + param.taskId;
    this.exportService.getExportExcel(url,param.taskNum);
  }

  // =============================实体素材三元组检索===============================
  // 根据关键字模糊匹配获取词条
  queryRdfName(param) {
    const url = this.rmsBasicApi + "materialRdf1/queryList";
    return this.http.Post(url, param);
  }

  // 根据词条名称、属性名称获取三元组数据
  queryRdfList(param) {
    const url = this.rmsBasicApi + "materialRdf1/queryRdfList";
    return this.http.Post(url, param);
  }

  // 批量修改素材三元组信息
  updateMaterialRdfs(param) {
    const url = this.rmsBasicApi + "materialRdf/updateMaterialRdfs";
    return this.http.Post(url, param);
  }

  // =============================素材统计===============================
  // 根据素材类型进行统计
  statisticMaterial(param) {
    const url = this.rmsBasicApi + "material/statisticMaterial";
    return this.http.Post(url, param);
  }

  // 根据素材获取方式进行统计
  statisticMaterialByAccessType(param) {
    const url = this.rmsBasicApi + "material/statisticMaterialByAccessType";
    return this.http.Post(url, param);
  }

  // 根据是否提取文字进行统计
  statisticMaterialByExtractStatus(param) {
    const url = this.rmsBasicApi + "material/statisticMaterialByExtractStatus";
    return this.http.Post(url, param);
  }

  // 根据提取知识实体数量进行统计
  statisticMaterialByInstanceCount(param) {
    const url = this.rmsBasicApi + "material/statisticMaterialByInstanceCount";
    return this.http.Post(url, param);
  }

  // =============================素材内容检索===============================
  // 素材检索关键字自动补全
  autoCompleWords(param) {
    const url = this.rmsBasicApi + "materialIndex/autoCompleWords";
    return this.http.Post(url, param);
  }

  // 全站素材内容检索
  highlightQuery(param) {
    const url = this.rmsBasicApi + "materialIndex/highlightQuery";
    return this.http.Post(url, param);
  }

  // 单个素材内容检索
  materialQuery(param) {
    const url = this.rmsBasicApi + "materialIndex/materialQuery";
    return this.http.Post(url, param);
  }

  // =============================实体资源管理===============================
  // 分页查询资源文件数据
  queryFileList(param) {
    const url = this.prefix + "fileInfo/queryList";
    return this.http.Post(url, param);
  }

  // 通过主键id查询资源文件数据
  queryFileById(param) {
    const url = this.prefix + "fileInfo/queryById/" + param;
    return this.http.Get(url);
  }

  // 通过主键id删除资源文件数据
  deleteFileById(param) {
    const url = this.prefix + "fileInfo/deleteById";
    return this.http.Post(url, param);
  }

  // 保存/更新资源文件
  batchSaveFiles(param) {
    const url = this.prefix + "fileInfo/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 通过id删除实体的资源文件数据
  deleteRelatedFileById(param) {
    const url = this.prefix + "material/removeResourceById";
    return this.http.Post(url, param);
  }

  // 保存/更新实体、标记与资源文件的关联关系
  saveFileRelationship(param) {
    const url = this.prefix + "material/saveFileRelationship";
    return this.http.Post(url, param);
  }

  //保存/更新实体与媒体资源文件信息(根据排序id排序)
  saveFileRelationshipById(param) {
    const url = this.prefix + "material/updateFileRel";
    return this.http.Post(url, param);
  }

  // 根据多个id查询资源文件列表
  batchQueryFiles(param) {
    const url = this.prefix + "fileInfo/queryListByInfoId";
    return this.http.Post(url, param);
  }
  
  // 查询实体或标记关联的资源文件列表
  queryRelatedFileList(param) {
    const url = this.prefix + "material/queryFileInfoList";
    return this.http.Post(url, param);
  }

  // ============================= 图像标记列表页===============================
  // 分页查询资源
  queryMaterialListByParams(param) {
    const url = this.prefix + "material/queryList";
    return this.http.Post(url, param);
  }

  // 批量更新图像资源编辑质检流程信息(图像指派、申领、分配质检员)
  batchUpdateImgEditorAndCheckUser(param) {
    const url = this.prefix + "material/batchUpdateEditorAndCheckUser";
    return this.http.Post(url, param);
  }

  // 批量更新图像资源状态(提交质检、质检、批量驳回、发布、撤销发布)
  batchUpdateImgStatus(param) {
    const url = this.prefix + "material/batchUpdateStatus";
    return this.http.Post(url, param);
  }

  // 质检审批并查询下一条标识
  queryNextMaterial(param) {
    const url = this.prefix + "material/queryNextMaterial";
    return this.http.Post(url,param);
  }
  

  // ============================= 图像标记详情页===============================
  // 分页查询图像标记
  queryImgMarks(param) {
    const url = this.prefix + "imageMark/queryList";
    return this.http.Post(url, param);
  }

  // 通过资源文件id查询所有标记信息
  queryMarkByParam(param) {
    const url = this.prefix + "imageMark/queryMarkByParam";
    return this.http.Post(url, param);
  }

  // 保存/更新图像标记
  saveOrUpdateImgMark(param) {
    const url = this.prefix + "imageMark/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // 删除图像标记
  deleteImgMarksById(param) {
    const url = this.prefix + "imageMark/deleteById";
    return this.http.Post(url, param);
  }

  // 通过主键id查询图像标记数据
  queryImgMarkById(param) {
    const url = this.prefix + "imageMark/queryById/" + param;
    return this.http.Get(url);
  }

  // 分页查询标记关联实体列表
  queryMarkRealtedInstance(param) {
    const url = this.prefix + "imageMark/queryRealtedInstanceList";
    return this.http.Post(url, param);
  }

  // 批量保存实体标记关联信息数据
  batchSaveMarkShip(param) {
    const url = this.prefix + "imageMark/batchSaveMarkShip";
    return this.http.Post(url, param);
  }

  // 通过实体标记关联id删除实体标记关联数据
  deleteMarkShipById(param) {
    const url = this.prefix + "imageMark/deleteMarkShipById";
    return this.http.Post(url, param);
  }

  // 根据文字生成音频文件
  geneTextAudio(param) {
    const url = this.prefix + "imageMark/geneTextAudio";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 通过主键id复制一份图像标记数据
  copyImageMark(param) {
    const url = this.prefix + "imageMark/copyImageMark";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }

  // 通过资源文件id查询被关联使用的实体
  findFileRelatedInstance(param) {
    const url = this.prefix + "imageMark/findFileRelatedInstance/" + param;
    return this.http.Get(url);
  }

  // 通过资源文件id统计进行标记的用户
  countMarkerUser(param) {
    const url = this.prefix + "imageMark/countMarkerUser/" + param;
    return this.http.Get(url);
  }

  // 自动切割图片生成标记
  autoGetImgMarks(param) {
    const url = this.imgSegmentationApi + "segment/segment_mask";
    return this.http.Post(url, param);
  }

  // 根据点集合，自动切割图片生成标记
  autoGetImgMarkByPoint(param) {
    const url = this.imgSegmentationApi + "segment/segment_point";
    return this.http.Post(url, param);
  }

  // 新增、修改、删除字后，重新获取排序后的数据
  ocrSort(param) {
    const url = this.ocrApi + "nsocr/sort";
    return this.http.Post(url, param);
  }

  // ============================= 标签管理===============================
  // 分页查询系统标签数据
  queryTagList(param) {
    const url = this.prefix + "systemTag/queryList";
    return this.http.Post(url, param);
  }

  // 查询系统标签分类树数据
  queryTagTree(param) {
    const url = this.prefix + "systemTag/queryTreeList";
    return this.http.Post(url, param);
  }

  // 通过主键id查询系统标签数据
  queryTagById(param) {
    const url = this.prefix + "systemTag/queryById/" + param;
    return this.http.Get(url);
  }

  // 根据标签名查询标签信息
  queryTagByName(param) {
    const url = this.prefix + "systemTag/queryByName/" + param;
    return this.http.Get(url);
  }

  // 通过主键id删除系统标签数据
  deleteTagById(param) {
    const url = this.prefix + "systemTag/deleteById";
    return this.http.Post(url, param);
  }

  // 保存/更新系统标签
  saveTag(param) {
    const url = this.prefix + "systemTag/saveOrUpdate";
    return this.http.Post(url, param);
  }

  // =============================操作日志===============================
  // 查询操作日志列表
  querySystemLog(param) {
    const url = this.prefix + "systemLog/queryList";
    return this.http.Post(url, param);
  }

  // =============================地图服务===============================

  // 通过名称分页查询地理位置数据
  getMapPointListData(param) {
    const url = this.mapBasicApi + "place/queryList";
    return this.http.Post(url, param);
  }

  // 通过主键删除地理位置坐标数据
  deleteMapPointById(id) {
    const url = this.mapBasicApi + "place/deleteById/" + id;
    return this.http.Get(url);
  }

  // 分页查询关联地理位置数据
  getAssociatedMapListData(param) {
    const url = this.prefix + "geoCoordinate/queryList";
    return this.http.Post(url, param);
  }

  // 删除实体的属性关联地理位置和节点
  deleteMapAttributeGeo(param) {
    const url = this.prefix + "geoCoordinate/deleteAttributeGeo";
    return this.http.Post(url, param);
  }

  // 通过主键id删除坐标关联关系
  deleteByPlaceId(param) {
    const url = this.prefix + "geoCoordinate/deleteByPlaceId";
    return this.http.Post(url, param, {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    });
  }
 
  // 先根据relationship和targetId删除，再批量保存新的坐标关联关系数据
  updateCoordRelationship(param) {
    const url = this.prefix + "geoCoordinate/updateCoordRelationship";
    return this.http.Post(url, param);
  }

  // 保存坐标关联关系数据
  saveCoordRelationship(param) {
    const url = this.prefix + "geoCoordinate/saveCoordRelationship";
    return this.http.Post(url, param);
  }

  // 保存实体坐标关联关系数据
  saveInstanceCoordRelationship(param) {
    const url = this.prefix + "geoCoordinate/saveInstanceCoordRelationship";
    return this.http.Post(url, param);
  }

  //#region 通用字典接口
  /**
   * 查询通用字典所有信息
   * @param param
   * @returns {Observable<any>}
   */
  queryDictionaryPageList(param) {
    const url = this.basicApi + "dictionary/queryPageList";
    return this.http.Post(url, param);
  }

  /**
   * 查看通用字典信息
   * @param param
   * @returns {Observable<any>}
   */
  getDictionary(param) {
    const url = this.basicApi + "dictionary/queryById";
    return this.http.Post(url, param);
  }

  /**
   * 更新通用字典信息
   * @param param
   * @returns {Observable<any>}
   */
  updateDictionary(param) {
    const url = this.basicApi + "dictionary/updateById";
    return this.http.Post(url, param);
  }

  /**
   * 删除通用字典单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteDictionary(param) {
    const url = this.basicApi + "dictionary/deleteBatch";
    return this.http.Post(url, param);
  }

  /**
   * 增加通用字典单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveDictionary(param) {
    const url = this.basicApi + "dictionary/save";
    return this.http.Post(url, param);
  }

  /**
   * 导出通用字典
   * @param param
   * @returns {Observable<any>}
   */
  exportDictionary(param) {
    const url = this.basicApi + "dictionary/export?parentId=" + param;
    this.exportService.getExportExcel(url, "通用字典");
  }

  /**
   * 根据code查询字典项
   *
   * @param param
   * @returns {Observable<any>}
   */
  getDictionaryByCode(param) {
    const url = this.basicApi + "dictionary/queryDictionaryByCode";
    return this.http.Post(url, param);
  }
  //#endregion
}
